import { useEffect, useRef  } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, Link } from "react-router-dom";
import { Row, Col, Button } from 'react-bootstrap';
import SitagLogo from '../../../../styles/images/sitag-logo.png';
import BackIcon from '../../../../styles/images/back-without-bg.png';
import ReactCodeInput from "react-code-input";
import { handleChangeTimerTimePageVerification, 
    handleChangeLoaderPageVerification, 
    handleChangeDisabledBtnPageVerification, 
    handleChangeBtnClassPageVerification, 
    handleChangeInputVerificationPage } from "../../../../redux/actions/pages/user/verification";
import { handleChangeInputReferalPage } from "../../../../redux/actions/pages/user/referal";
import { handleChangeInputLoginPage } from "../../../../redux/actions/pages/user/login";
import { handleChangeProfileData, handleChangeToken } from "../../../../redux/actions/pages/user/user";
import { handleSetBackdropLoading } from '../../../../redux/actions/loaders';
import { BASE_SITE, RESEND_ACTIVATION_COD_POST, USERS_ACTIVATION_POST } from '../../../../apis'; 
import Swal from 'sweetalert2';
import axios from "axios";
import * as qs from "querystring";


const Verification = () => {

    const dispatch = useDispatch();
    const navigate = useNavigate();


    const { phoneNumber } = useSelector(state => state.login);
    const { code, timer_time, disabledBtn, isLoading, btnClass } = useSelector(state => state.verification);

    useEffect(() => {
        handleTimerTime();
        // eslint-disable-next-line
    }, [timer_time]);


    const containerRef = useRef(null);
    useEffect(() => {
        openKeyboard();
        // // eslint-disable-next-line
    }, [Verification]);
    const openKeyboard = () => {
        if (containerRef.current) {
            const firstInput = containerRef.current.querySelector('input');
            if (firstInput) {
                firstInput.focus();
            }
        }
    }





    let setTimeOut;
    const handleTimerTime = () => {
        if (timer_time > 0)
            setTimeOut = setTimeout(() => {
                if (timer_time > 0) {
                    dispatch(handleChangeTimerTimePageVerification(timer_time - 1));
                } else
                    clearTimeout(setTimeOut);
            }, 1000);
        else {
            if (timer_time !== 0)
                dispatch(handleChangeTimerTimePageVerification(0));
        }
    };

    const handleBackBtn = () => {
        navigate(-1);
    };


    const btnOkSingle = Swal.mixin({
        customClass: {
            confirmButton: 'primary-border primary-txt-color font-weight-300 radius-12 w-100 py-2 px-5',
        },
        buttonsStyling: false
    });


    const handleBtnResendCodeActivation = () => {
        if(timer_time === 0 && !isLoading) {

            dispatch(handleSetBackdropLoading(true));
            dispatch(handleChangeLoaderPageVerification(true));

            axios({
                method: 'post',
                url: BASE_SITE + RESEND_ACTIVATION_COD_POST,
                data: qs.stringify({
                    mobile: phoneNumber
                }), headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/x-www-form-urlencoded'
                },
            }).then((response) => {
                switch (response.data.status) {
                    case 'error':
                        btnOkSingle.fire({
                            title: "خطا در ارسال کد",
                            text: response.data.message,
                            imageUrl: SitagLogo,
                            imageHeight: 80,
                            imageAlt: 'سیتگ',
                            confirmButtonText: "تایید",
                        });
                        break;
                    case 'ok':
                        dispatch(handleChangeTimerTimePageVerification(parseInt(response.data.timer_time)));
                        openKeyboard();
                        break;
                    default:
                        btnOkSingle.fire({
                            title: "خطا در ارسال کد",
                            text: "لطفا مجددا تلاش کنید.",
                            imageUrl: SitagLogo,
                            imageHeight: 80,
                            imageAlt: 'سیتگ',
                            confirmButtonText: "تایید",
                        });
                }
                dispatch(handleSetBackdropLoading(false));
                dispatch(handleChangeLoaderPageVerification(false));
            }, () => {
                dispatch(handleSetBackdropLoading(false));
                dispatch(handleChangeLoaderPageVerification(false));
                btnOkSingle.fire({
                    title: "خطا در ارسال کد",
                    text: "لطفا مجددا تلاش کنید.",
                    imageUrl: SitagLogo,
                    imageHeight: 80,
                    imageAlt: 'سیتگ',
                    confirmButtonText: "تایید",
                });
            });
        }
    };


    const handleChangeInputCodePageVerification = (event) => {
        const {name, value} = typeof event === 'string' ? {name: "code", value: event} : event.target;
        dispatch(handleChangeInputVerificationPage(name, changeNumberPersianAndArabic(value)));
    };

    const changeNumberPersianAndArabic = (str) => {
        let
            persianNumbers = [/۰/g, /۱/g, /۲/g, /۳/g, /۴/g, /۵/g, /۶/g, /۷/g, /۸/g, /۹/g],
            arabicNumbers = [/٠/g, /١/g, /٢/g, /٣/g, /٤/g, /٥/g, /٦/g, /٧/g, /٨/g, /٩/g];
        if (typeof str === 'string') {
            for (let i = 0; i < 10; i++) {
                str = str.replace(persianNumbers[i], i).replace(arabicNumbers[i], i);
            }
        }
        return str;
    }

    useEffect(() => {
        handleActivationBtn();
    }, [code]);

    const handleActivationBtn = () => {
        if (code.length === 4 && !isLoading) {
            dispatch(handleChangeBtnClassPageVerification());
            // toast.warning('در حال بررسی کد فعال سازی', {
            //     position: toast.POSITION.BOTTOM_CENTER
            // });
            apiActivation();
        }
        else
            dispatch(handleChangeBtnClassPageVerification('disable-btn'));
    };

    const apiActivation = () => {
        if (code.length === 4 && !isLoading)
        {
            dispatch(handleSetBackdropLoading(true));
            dispatch(handleChangeLoaderPageVerification(true));
            dispatch(handleChangeBtnClassPageVerification('disable-btn'));


            var postData = {code: code};
            axios({
                method: 'post',
                url: BASE_SITE + USERS_ACTIVATION_POST,
                data: qs.stringify(postData), 
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/x-www-form-urlencoded'
                },
            }).then((response) => {
                switch (response.data.status) {
                    case 'error':
                        btnOkSingle.fire({
                            title: "خطا در  فعال سازی",
                            text: response.data.message,
                            imageUrl: SitagLogo,
                            imageHeight: 80,
                            imageAlt: 'سیتگ',
                            confirmButtonText: "تایید",
                        });
                        break;
                    case 'ok':
                        /***
                        gharar shod referal code ejbari bashe, be hamin khater 
                        dispatch(handleChangeProfileData(response.data.info));
                        dispatch(handleChangeToken(response.data.token));
                        ro comment kardim va sharthaye marboot be show_referal_page ro gozashtim
                        hala goftan ekhtiyari bashe, pas baz un 2 khat ro az comment dar miyarim
                        ***/

                        dispatch(handleChangeProfileData(response.data.info));
                        dispatch(handleChangeToken(response.data.token));

                        dispatch(handleChangeInputVerificationPage('code', ''));
                        dispatch(handleChangeInputVerificationPage('timer_time', 0));
                        dispatch(handleChangeInputVerificationPage('disabledBtn', true));
                        dispatch(handleChangeInputVerificationPage('isLoading', false));
                        dispatch(handleChangeInputVerificationPage('btnClass', 'disable-btn'));

                        dispatch(handleChangeInputLoginPage('phoneNumber', ''));


                        if(!response.data.show_referal_page) {
                            // dispatch(handleChangeProfileData(response.data.info));
                            dispatch(handleChangeInputReferalPage('showReferalPage', false));
                            // dispatch(handleChangeToken(response.data.token));
                        }
                        else {
                            dispatch(handleChangeInputReferalPage('temporaryToken', response.data.token));
                            dispatch(handleChangeInputReferalPage('showReferalPage', true));
                        }

                        // navigate.reset({index: 0, routes:[{name: 'wallet'}]});
                        break;
                    default:
                        btnOkSingle.fire({
                            title: "خطا در  فعال سازی",
                            text: "لطفا مجددا تلاش کنید.",
                            imageUrl: SitagLogo,
                            imageHeight: 80,
                            imageAlt: 'سیتگ',
                            confirmButtonText: "تایید",
                        });
                        // handelChangeInputCodeModalLogin('');
                }
                dispatch(handleSetBackdropLoading(false));
                dispatch(handleChangeLoaderPageVerification(false));
                dispatch(handleChangeBtnClassPageVerification(''));
            }, () => {
                btnOkSingle.fire({
                    title: "خطا در  فعال سازی",
                    text: "لطفا مجددا تلاش کنید.",
                    imageUrl: SitagLogo,
                    imageHeight: 80,
                    imageAlt: 'سیتگ',
                    confirmButtonText: "تایید",
                });
                dispatch(handleSetBackdropLoading(false));
                dispatch(handleChangeLoaderPageVerification(false));
                dispatch(handleChangeBtnClassPageVerification(''));
            });
        }
    };


    const propsCode = {
        className: '',
        inputStyle: {
            margin: 'calc(2px + (8 - 2) * ((100vw - 320px) / (1920 - 320)))',
            backgroundColor: '#f6f5fa',
            fontSize: '14px',
            padding: 'calc(8px + (14 - 8) * ((100vw - 320px) / (1920 - 320))) calc(12px + (15 - 12) * ((100vw - 320px) / (1920 - 320)))',
            borderRadius: '0.25rem',
            textAlign: 'center',
            overflow: 'visible',
            width: '52px',
            class: 'custom-vertical-padding',
        },
        inputStyleInvalid: {
            margin: 'calc(2px + (8 - 2) * ((100vw - 320px) / (1920 - 320)))',
            backgroundColor: '#fff',
            fontSize: '14px',
            padding: 'calc(8px + (14 - 8) * ((100vw - 320px) / (1920 - 320))) calc(12px + (15 - 12) * ((100vw - 320px) / (1920 - 320)))',
            borderRadius: '0.25rem',
            textAlign: 'center',
            overflow: 'visible',
            width: '52px',
        }
    }

    return (

        <div id="verification-page">
            <Row className="pt-5">
                <Col xs={1} className="d-flex align-items-center"><img src={BackIcon} alt="back" onClick={handleBackBtn} role="button" /></Col>
                <Col xs={10} className="text-center">
                    <div className="header_h3">
                        به 
                        <Link to=".."><img src={SitagLogo} className="logo-in-txt mx-2" alt="سیتگ" /></Link>
                        خوش آمدید
                    </div>
                </Col>
                <Col xs={1}></Col>
                <Col xs={12} className="text-center mt-3">
                    کد ارسال شده به شماره {phoneNumber} را وارد کنید
                </Col>
            </Row>

            <Row className="mt-4">
                <Col className="text-center mt-4" ref={containerRef}>
                    <ReactCodeInput 

                        type='number' 
                        inputMode="numeric" 
                        fields={4} 
                        name={'code'} 
                        id="input-code" 
                        value={code} 
                        autocomplete={'one-time-code'}
                        style={{direction: 'ltr'}}
                        pattern="[0-9]*"
                        placeholder="-"
                        autoFocus={false}
                        onChange={handleChangeInputCodePageVerification}
                        {...propsCode} />
                </Col>
            </Row>

            <Row className="mt-4 small-txt" >
                <Col xs={12} className="text-left mt-1 font-12">
                    <span onClick={handleBackBtn} role="button" className="small-txt">
                        ویرایش شماره موبایل
                    </span>
                </Col>
                <Col xs={12} className={"text-left mt-3 " + (timer_time > 0 ? " disable-txt" : "")}  >
                    <span onClick={handleBtnResendCodeActivation} role="button">
                        ارسال مجدد کد  
                        {timer_time > 0 ?
                            ` (${timer_time})`
                            : ''
                        }
                    </span>
                </Col>
            </Row>

            <Row className="mt-1">
                <Col className="text-center mt-4">
                    <Button className={`w-100 custom-vertical-padding login-form-button ${btnClass}`} onClick={handleActivationBtn} >
                        فعالسازی
                    </Button>
                </Col>
            </Row>

        </div>

    );
}

export default Verification;